import dynamic from 'next/dynamic';
import pkg from '../package.json';
import { PLUGIN_NAME } from './constants';
export default async function load(app) {
  app.events.once('load:custom:page-builder:component', addComponent => {
    addComponent({
      key: 'gtm',
      component: dynamic(() => import(/* webpackChunkName: "blazePbGoogleTagManager" */'./GoogleTagManager'))
    });
    addComponent({
      key: 'gtm-events',
      component: dynamic(() => import(/* webpackChunkName: "blazePbGoogleTagManagerEvent" */'./GoogleTagManagerEvent'))
    });
  });
  return {
    name: PLUGIN_NAME,
    version: pkg.version
  };
}
load.pluginName = PLUGIN_NAME;
//# sourceMappingURL=index.js.map